// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".side[data-v-34f78a7b] {\n  position: absolute;\n  bottom: 0.02604rem;\n  top: 0.54688rem;\n  z-index: 9;\n}\n@media (max-width: 1366px) {\n.side[data-v-34f78a7b] {\n    top: 0.33854rem;\n}\n}\n@media (max-width: 1280px) {\n.side[data-v-34f78a7b] {\n    top: 0.5625rem !important;\n}\n}\n.right[data-v-34f78a7b] {\n  right: 0.02604rem;\n}\n.left[data-v-34f78a7b] {\n  left: 0.02604rem;\n}\n", ""]);
// Exports
module.exports = exports;
